import Component from '@bythepixel/component-loader';

export default class toggleButton extends Component {
  static selector = '[comp-mobile-nav-toggle]'
  constructor(...args) {
    super(...args);
    this.events();
  }

  events() {
    this.$container.addEventListener('click', () => {
      this.$publish('mobile-nav-menu:toggle', 'toggle');
    });
  }
}
